import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Simulated inbox for tutorial onboarding.
 * Shows only the welcome gift message so the user can practice accepting it.
 */
const SimulatedInbox = ({ onAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleAccept = () => {
    setAccepted(true);
    timeoutRef.current = setTimeout(() => {
      onAccept?.();
    }, 1200);
  };

  return (
    <div className="simulated-inbox-backdrop">
      <AnimatePresence>
        {!accepted && (
          <motion.div
            className="simulated-inbox-container"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.35 }}
          >
            <div className="simulated-inbox-header">
              <h2>📬 Mensajes</h2>
              <span className="simulated-inbox-close">×</span>
            </div>

            <div className="simulated-inbox-list">
              <div className="simulated-inbox-message active">
                <div className="simulated-inbox-icon">🎁</div>
                <div className="simulated-inbox-content">
                  <div className="simulated-inbox-title-row">
                    <span className="simulated-inbox-title">¡Tienes un regalo!</span>
                    <span className="simulated-inbox-badge">Nuevo</span>
                  </div>
                  <p className="simulated-inbox-body">
                    Bienvenido a MundoXYZ! Disfruta tu bono de bienvenida.
                  </p>
                  <div className="simulated-inbox-rewards">
                    <span className="reward-coins">🪙 500 Coins</span>
                    <span className="reward-fires">🔥 100 Fires</span>
                  </div>
                  <button
                    className="simulated-inbox-accept-btn"
                    onClick={handleAccept}
                  >
                    Aceptar Bienvenida
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        )}

        {accepted && (
          <motion.div
            className="simulated-inbox-success"
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            <div className="success-icon">🎉</div>
            <h3>¡Regalo recibido!</h3>
            <p>500 Coins y 100 Fires han sido añadidos a tu cuenta.</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SimulatedInbox;
